import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v } from '@dojo/framework/core/vdom';
import { Keys } from '@holmescorp/common';
import { I18nThemed } from '@holmescorp/interfaces/mixins';
import { keymap, pathmap } from '@holmescorp/lcc-state';
import css from '../css/topicset.m.css';
let TopicSet = class TopicSet extends I18nThemed {
    toc_click() {
        const { topic: { attributes = {} } } = this.properties;
        const { key } = attributes;
        console.log('toc action for', key);
    }
    head_click() {
        const { topic: { attributes = {} } } = this.properties;
        const { key } = attributes;
        const { path } = keymap.get(key);
        const { view } = pathmap.get(path);
        view();
    }
    render() {
        const { topic: { attributes = {} }, as_toc = false } = this.properties;
        const { title, key } = attributes;
        return v('div', {
            key,
            tabIndex: 0,
            classes: [this.theme(css.root)],
            onclick: (event) => {
                event && event.stopImmediatePropagation();
                as_toc ? this.toc_click() : this.head_click();
            },
            onkeydown: (event) => {
                const { as_toc } = this.properties;
                switch (event.key) {
                    case Keys.Enter:
                    case Keys.Space:
                    case Keys.Spacebar:
                        event.preventDefault();
                        as_toc ? this.toc_click() : this.head_click();
                        break;
                }
            }
        }, [v('div', { classes: [this.theme(css.title)] }, [title])]);
    }
};
TopicSet = __decorate([
    theme(css)
], TopicSet);
export { TopicSet };
